// extracted by mini-css-extract-plugin
export var active = "Slider-module--active--5b302";
export var button = "Slider-module--button--ea175";
export var button__left = "Slider-module--button__left--836f4";
export var button__right = "Slider-module--button__right--56d17";
export var chevron = "Slider-module--chevron--3b1e8";
export var dot = "Slider-module--dot--60dbf";
export var dots = "Slider-module--dots--b2835";
export var inner = "Slider-module--inner--83fd9";
export var wrapper = "Slider-module--wrapper--0c1e6";